import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';

import SocialMediaIcons from '../../atoms/SocialMediaIcons';
import ProductLogo from '../../atoms/ProductLogo';
import DashBoardButton from '../../atoms/DashBoardButton';
import {
  isGeoMotionVideo,
  isMaps,
  isIAS,
  isBoilerPlate,
  isLuminarias
} from '../../../modules/checkDeployEnv';
import Styles from './styles';
import HomeMaps from './HomeMaps';

const { productName, showSlogan } = Meteor.settings.public;

const IAS_SLOGAN = 'The only drone tool you\u0027ll ever need.';
const MAPS_SLOGAN = 'The georeferentiation of everything';
const GMV_SLOGAN = showSlogan ? 'The only video geo reference tool you\u0027ll ever need.' : '';
const BOILERPLATE_SLOGAN = 'The only boilerplate tool you\u0027ll ever need.';
const SRM_AUTHORITY = 'by SRM Consulting';

const Home = props => {
  const { authenticated, deployEnv, history } = props;
  let slogan = '';
  switch (true) {
    case isGeoMotionVideo(deployEnv):
      slogan = GMV_SLOGAN;
      break;
    case isMaps(deployEnv):
    case isLuminarias(deployEnv):
      slogan = MAPS_SLOGAN;
      break;
    case isIAS(deployEnv):
      slogan = IAS_SLOGAN;
      break;
    case isBoilerPlate(deployEnv):
      slogan = BOILERPLATE_SLOGAN;
      break;
    default:
      slogan = IAS_SLOGAN;
      break;
  }
  return (
    <Styles.Home deployEnv={deployEnv}>
      <ProductLogo deployEnv={deployEnv} />
      <p>{!isGeoMotionVideo(deployEnv) || showSlogan ? SRM_AUTHORITY : ''}</p>
      <p>{slogan}</p>
      <DashBoardButton history={history} deployEnv={deployEnv} />
      <p>{`Don\u0027t forget to like and follow ${productName} elsewhere on the web:`}</p>
      <SocialMediaIcons />
      {authenticated === true && <HomeMaps {...props} />}
    </Styles.Home>
  );
};
Home.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  deployEnv: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

export default Home;
